import { OrderReviewAssets } from '../../../../order-review/view/stores/OrderReviewStore';
import { AuthAssets, AuthTexts } from '../../../view/stores/AuthStore';
import {
  AuthContentVM,
  ImageVM,
  ResendOptionVM,
} from '../../entities/auth-content/AuthContentVM.type';

const toIcon = (asset: { src: string; alt: string }): ImageVM => ({
  path: asset.src,
  altText: asset.alt,
});

// The CMS ships a desktop banner + a separate mobile banner per modal.
const DEFAULT_BANNER: ImageVM = toIcon(AuthAssets.desktopBanner);
const DEFAULT_MOBILE_BANNER: ImageVM = toIcon(AuthAssets.mobileBanner);

const toResendOption = (
  option: (typeof AuthTexts.resendOptionsModal.resendOptions)[number],
): ResendOptionVM => ({
  value: option.value,
  text: option.content.text,
  subText: option.content.subtext,
  icon: { path: option.content.image.src, altText: option.content.image.alt },
});

export const DEFAULT_AUTH_CONTENT: AuthContentVM = {
  loginModal: {
    title: AuthTexts.loginModal.title,
    description: AuthTexts.loginModal.description,
    submitCta: AuthTexts.submitCta,
    agreementPolicy: AuthTexts.agreementPolicy,
    banner: DEFAULT_BANNER,
    mobileBanner: DEFAULT_MOBILE_BANNER,
    phoneField: {
      placeholder: AuthTexts.loginModal.phonePlaceholder,
      errorText: AuthTexts.invalidMobile,
      icon: toIcon(AuthAssets.callIcon),
    },
  },
  signupModal: {
    title: AuthTexts.signupModal.title,
    description: AuthTexts.signupModal.description,
    checkboxText: AuthTexts.signupModal.whatsappConsent,
    submitCta: AuthTexts.submitCta,
    agreementPolicy: AuthTexts.agreementPolicy,
    banner: DEFAULT_BANNER,
    mobileBanner: DEFAULT_MOBILE_BANNER,
    nameField: {
      placeholder: AuthTexts.signupModal.namePlaceholder,
      icon: toIcon(AuthAssets.userIcon),
    },
    phoneField: {
      placeholder: AuthTexts.signupModal.phonePlaceholder,
      errorText: AuthTexts.invalidMobile,
      icon: toIcon(AuthAssets.callIcon),
    },
    emailField: {
      placeholder: AuthTexts.signupModal.emailPlaceholder,
      icon: toIcon(AuthAssets.mailIcon),
    },
  },
  otpModal: {
    title: AuthTexts.otpModal.title,
    otpSentMessage: AuthTexts.otpModal.otpSentMessage,
    otpSentMessageMobile: AuthTexts.otpModal.otpSentMessageFull,
    changeMobile: AuthTexts.otpModal.changeMobile,
    errorMessage: AuthTexts.otpModal.errorMessage,
    tooManyAttempts: AuthTexts.otpModal.resendOtp.tooManyAttempts,
    notReceivedText: AuthTexts.otpModal.resendOtp.notReceived,
    resendText: AuthTexts.otpModal.resendOtp.resend,
    resendInText: AuthTexts.otpModal.resendOtp.resendIn,
    invalidOtp: AuthTexts.otpInvalid,
    cta: AuthTexts.otpModal.cta,
  },
  resendOptionsModal: {
    title: AuthTexts.resendOptionsModal.title,
    confirmCta: AuthTexts.resendOptionsModal.resendConfirmBtn,
    options: AuthTexts.resendOptionsModal.resendOptions.map(toResendOption),
  },
  backIcon: toIcon(OrderReviewAssets.arrowLeftIcon),
  closeIcon: toIcon(AuthAssets.crossBlackIcon),
};
